export default __webpack_public_path__ + "static/Panasonic_MN34229_Night-715b9d1d83ed46ddb723ca77e3db60da.webp";